import { useNavigate } from 'react-router-dom'
import { ButtonGroup, Button } from '@mui/material'

const Menu = () => {

  const navigate = useNavigate()

  const page = location.pathname.split("/").pop()

  return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <ButtonGroup variant="text" aria-label="Actions">
        <Button onClick={() => navigate("../history")} sx={{color:page === "history" ? "link" : "text.secondary"}}>History</Button>
        <Button onClick={() => navigate("../new")} sx={{color:page === "new" ? "link" : "text.secondary"}}>New Support Request</Button>
      </ButtonGroup>
    </div>

  )
}

export default Menu